import { Component, ElementRef, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ToastService } from '@ibe.components/common/toast/toast.service';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
	host: {
		class: 'app-toast'
	}
})
export class ToastComponent implements OnInit, OnDestroy {
	@ViewChild('toast') $toastElem: ElementRef;

	@HostBinding('class.is-open')
	isOpen: boolean;
	@HostBinding('attr.aria-hidden')
	isAriaHidden: boolean;

	isAlive = true;
	lastActiveElement;

	message: string;
	duration;
	type;
	showClose = false;
	lookScreen = true;

  constructor(private toastService: ToastService) { }

  ngOnInit() {
  	this.isAlive = true;

		this.toastService.isOpen.pipe(takeWhile(() => this.isAlive)).subscribe(
			value => {
				this.isOpen = value;

				if (this.isOpen) {
					this.lastActiveElement = document.activeElement;
					this.$toastElem.nativeElement.focus();
					if (this.duration > 0) {
						window.setTimeout(this.dismissToast.bind(this), this.duration * 1000);
					}
				} else if (this.lastActiveElement !== undefined) {
					this.lastActiveElement.focus();
				}

				this.isAriaHidden = !value;
			},
			error => console.error(error),
			() => {}
		);

		this.toastService.message.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.message = value;
		});

		this.toastService.duration.pipe(takeWhile(() => this.isAlive)).subscribe( value => {
			this.duration = value;
		});

		this.toastService.type.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.type = value;
		});
		
		this.toastService.showClose.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.showClose = value;
		});
  }

  dismissToast() {
		this.toastService.close();
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	TAP_getTabindex() {
		return this.isOpen ? 0 : -1;
	}
}
